import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";


//////////////////////////// For Training Report ////////////////////////
export const fetchTrainingReport = createAsyncThunk('dashboard/trainingreport', async (reqBody) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(reqBody)
  }
  console.log("reqBody====>", reqBody)
  const response = await fetch(`${process.env.REACT_APP_API_URL}api3/trainingdatafetching`, requestOptions);
  const res = response.json();
  return res;
})

//////////////////////////////////for productaccessofshop//////////////////////////////////////////

export const productAccessOfShop = createAsyncThunk("productaccessofshop", async (reqbody) => {
  console.log("reqbody==>", reqbody);

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(reqbody),
  };
  const response = await fetch(
    process.env.REACT_APP_API_URL + "api/productaccessofshop",
    requestOptions
  );
  const respdata = await response.json();
  console.log("productaccessofshop fetch==>", respdata);
  return respdata;
}
);


export const fetchLoggedUserData = createAsyncThunk('logged/user', async (reqBody) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(reqBody)
  }

  const response = await fetch(`${process.env.REACT_APP_API_URL}api/fetchoneloginusre`, requestOptions);

  const resp = await response.json();

  return resp;
})
/////////////////////////////////////////////////////For manager account type change end point call//////////////////////
export const userAccountChange = createAsyncThunk('logged/user', async (reqbody) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(reqbody)
  }

  const response = await fetch(`${process.env.REACT_APP_API_URL}api6/usertypechange`, requestOptions);

  const resp = await response.json();

  return resp;
})


export const getCityList = createAsyncThunk(
  "adminDashboard/adminlist",
  async (reqbody) => {
    console.log("reqbody==>", reqbody);

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(reqbody),
    };
    console.log("process.env==>", process.env);
    const response = await fetch(
      process.env.REACT_APP_API_URL + "api/statewithCity",
      requestOptions
    );
    const respdata = await response.json();
    console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
  }
);

export const getList = createAsyncThunk("adminDashboard/list", async () => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}api/listingusers`
  );
  const resData = await response.json();
  console.log("getList==>", resData);

  return resData;
});

//////////////////////////////////for my account//////////////////////////////////////////
export const getUserData = createAsyncThunk("myaccount", async (reqbody) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(reqbody),
  };
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}api/userdetails`, requestOptions
  );
  const resData = await response.json();
  console.log("getUserData==>", resData);

  return resData;
});

//////////////////////////////////for topoff//////////////////////////////////////////
export const getPieChartData = createAsyncThunk("userDashboard/pieChartData", async (reqbody) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(reqbody),
  };
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}api6/dataforpichart`, requestOptions
  );
  const resData = await response.json();
  console.log("getPieChartData==>", resData);

  return resData;
});
//////////////////tpm edit///////////////////
export const addEditTpm = createAsyncThunk(
  "dashboard/updateTpm",
  async (updatedDataBody) => {
    let req_body = {};
    req_body.data = updatedDataBody;
    console.log(
      "newData and oldData ++++++++++++++++++++++++++++++++=",
      updatedDataBody
    );
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(req_body),
    };
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api6/addedittpm`,
      requestOptions
    );
    const updatedUser = await response.json();
    console.log("updatedUser----------------------------------", updatedUser);

  }
);
///////////////////////tpm multi delete///////////////////
export const multideletetpm = createAsyncThunk(
  "multideletetpm",
  async (deleteMany) => {
    console.log("delete----------------------------------", deleteMany);
    let req_body = {};
    req_body._ids = deleteMany;
    req_body._ids = deleteMany.onlyids;
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(req_body),
    };
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}api6/deletemanytpm`,
      requestOptions
    );
    const res = await response.json();
    console.log("res delete----------------------------------", res);

    return res;
  }
);

///////////////////////topoff multi delete///////////////////
export const multideletetopoff = createAsyncThunk(
  "multideletetopoff",
  async (deleteMany) => {
    console.log("delete----------------------------------", deleteMany);
    let req_body = {};
    req_body._ids = deleteMany;
    req_body._ids = deleteMany.onlyids;
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(req_body),
    };
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}api6/deletemanytopoff`,
      requestOptions
    );
    const res = await response.json();
    console.log("res delete----------------------------------", res);

    return res;
  }
);
export const addUser = createAsyncThunk(
  "area_director-dashboard/add",
  async (addUserBody) => {
    let req_body = {};
    req_body.data = addUserBody;
    console.log("req_body==", req_body, "addUserBody", addUserBody);
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(req_body),
    };
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}api/addorupdateusers`,
      requestOptions
    );
    const addedUser = await response.json();
    console.log("addedUser==", addedUser);
    addedUser.newData = addUserBody;
    return addedUser;
  }
);

export const updateUser = createAsyncThunk(
  "dashboard/updateUser",
  async (updatedDataBody) => {
    let req_body = {};
    req_body.data = updatedDataBody;
    console.log(
      "newData and oldData ++++++++++++++++++++++++++++++++=",
      updatedDataBody
    );
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(req_body),
    };
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}api/addorupdateusers`,
      requestOptions
    );
    const updatedUser = await response.json();
    console.log("updatedUser----------------------------------", updatedUser);
    return updatedUser;
  }
);



export const getdataforuser = createAsyncThunk(
  "dashboard",
  async (reqBody) => {
    console.log('newData and oldData ++++++++++++++++++++++++++++++++=');

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(reqBody),
    };
    console.log("Next step", reqBody)
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}api3/userlistasync`,
      requestOptions
    );
    console.log("Next 222 step", response)
    const updatedUserfordashboard = await response.json();
    console.log(
      "dashboard----------------------------------",
      updatedUserfordashboard
    );

    return updatedUserfordashboard;
  }
);

export const getdataforusernext = createAsyncThunk(
  "dashboard/next",
  async (reqBody) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(reqBody),
    };
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}api3/userlistasyncone`,
      requestOptions
    );
    console.log("Next 222 step", response)
    const res = await response.json();

    return res;
  }
);
///////////////////delete multiple/////////////////
export const multidelete = createAsyncThunk(
  "multideleteuser",
  async (deleteMany) => {
    console.log("delete----------------------------------", deleteMany);
    let req_body = {};
    req_body._ids = deleteMany;
    req_body._ids = deleteMany.onlyids;
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(req_body),
    };
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}api/deleteusermany`,
      requestOptions
    );
    const res = await response.json();
    console.log("res delete----------------------------------", res);

    return res;
  }
);


///////////////////////////////// Edit Multiple Item form Table //////////////////////////////////
export const statusUpdate = createAsyncThunk("statusUpdateuser", async (reqbody) => {

  let req_body = {};
  req_body = reqbody.editData;
  console.log("reqbody==", reqbody)
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(req_body)
  };
  const response = await fetch(process.env.REACT_APP_API_URL + "api/onlystatusupdate", requestOptions);
  const respdataforstatusUpdate = await response.json();

  return respdataforstatusUpdate;
});




const userdashboard = createSlice({
  name: "adminDashboard",
  initialState: {
    submitting: false,
    cities: [],
    users: [],
    profileinfo: [],
    submitted: false,
    message: null,
    userlistasyncdata: {},
    userlistasyncflag: false,
    loading: false,
    success: {},
    successmsg: "",
    store_access: null,
    store_access_flag: false,
    tpmcount: null,
    topoffdataforpichart: null,
    pichartdayscount: null,
    loggedUserData: {},
    trainingreport: [],
    manageAccountflag:{},
    tpm_topoff_access_flag:0,
    userlistasyncone_flag: 0
    

    // addUserData: []
  },
  reducers: {
    setSuccessAfterSubmit(state, action) {
      state.success[action.payload.tableId] = false;
    },

    setProductAccessOfShop(state, action) {
      state.store_access = action.payload.store_access;
    },

    resetManageaccountflag(state, action) {
      state.manageAccountflag = {}
    },
    resetTpmTopoffflag(state, action) {
      state.tpm_topoff_access_flag = 0
    },
    resetUserlistasyncone_flag(state, action){
      state.userlistasyncone_flag=0 
    }



  },
  extraReducers: {
    //////////////////////////////////// For Training Report ///////////////////////////////
    [fetchTrainingReport.pending]: (state, action) => {
      state.loading = true;
    },
    [fetchTrainingReport.fulfilled]: (state, action) => {
      state.loading = false;
      if (action.payload.status === 'success') {
        state.trainingreport = action.payload.results.res
      }
    },
    [fetchTrainingReport.rejected]: (state, action) => {
      state.loading = false;
    },
    /////////////////////////////////////// fetch Data of logged user ////////////////////////////
    [fetchLoggedUserData.pending]: (state, action) => {
      state.loading = true;
    },
    [fetchLoggedUserData.fulfilled]: (state, action) => {
      state.loading = false;
      if (action.payload.status === 'success') {
        state.loggedUserData = action.payload.results.res;
      }
    },
    [fetchLoggedUserData.rejected]: (state, action) => {
      state.loading = false;
    },


    //////////////////////////////////// Fetching store access ///////////////////////////////
    [productAccessOfShop.pending]: (state, action) => {
      // state.store_access = 0;
    },
    [productAccessOfShop.fulfilled]: (state, action) => {
      state.store_access = action.payload.results.res.store_access;
      state.store_access_flag = true;
    },
    [productAccessOfShop.rejected]: (state, action) => {
      // state.store_access = ["No store access Found !"];
    },





    //////////////////////////// Edit Multiple Item ///////////////////////////////
    [statusUpdate.pending]: (state, action) => {
      state.loading = true;
    },
    [statusUpdate.fulfilled]: (state, action) => {
      if (action.payload.status === "success") {
        state.loading = false;
        state.successmsg = 'Updated Successfully'
        state.success[action.meta.arg.tableId] = true;
      }
    },
    [statusUpdate.rejected]: (state, action) => {
      state.loading = false;
      state.successmsg = 'Something went wrong';
    },

    //////////////////////////// Delete Multiple User ///////////////////////////////
    [multidelete.pending]: (state, action) => {
      state.loading = true;
      //   state.loading[action.meta.arg.tableId] = true;
    },
    [multidelete.fulfilled]: (state, action) => {
      if (action.payload.status === "success") {
        state.loading = false;
        state.successmsg = 'Deleted Successfully';
        state.success[action.meta.arg.tableId] = true;
      }
      //   state.loading[action.payload.tableId] = false;
      //   if (action.payload.status === "success") {
      //     console.log("action", action);
      //     console.log("state.tableData[action.payload.tableId]", state.tableData);
      //     // console.log(state.tableData[action.payload.tableId].findIndex(cur => cur._id === action.payload.id));
      //     // state.tableData[action.payload.tableId].splice(state.tableData[action.payload.tableId].findIndex(cur => cur._id === action.payload.id), 1);
      //     // state.count[action.payload.tableId] -= 1;
      //   }
      //   if (action.payload.status === "error") {
      //     state.snackbarMessage = "Something Went Wrong";
      //   }
    },
    [multidelete.rejected]: (state, action) => {
      state.loading = false;
      state.successmsg = 'Something went wrong';
      //   console.log("state.loading[action.meta.arg.tableId] 666", state);
      //   state.loading[action.meta.arg.tableId] = false;
      //   state.snackbarMessage = "Something Went Wrong";
    },
    //////////////////////////// Delete Multiple tpm ///////////////////////////////
    [multideletetpm.pending]: (state, action) => {
      state.loading = true;
    },
    [multideletetpm.fulfilled]: (state, action) => {
      if (action.payload.status === "success") {
        state.loading = false;
        state.successmsg = 'Deleted Successfully';
        state.success[action.meta.arg.tableId] = true;
      }
    },
    [multideletetpm.rejected]: (state, action) => {
      state.loading = false;
      state.successmsg = 'Something went wrong';
    },

    //////////////////////////// Delete Multiple tpm ///////////////////////////////
    [multideletetopoff.pending]: (state, action) => {
      state.loading = true;
    },
    [multideletetopoff.fulfilled]: (state, action) => {
      if (action.payload.status === "success") {
        state.loading = false;
        state.successmsg = 'Deleted Successfully';
        state.success[action.meta.arg.tableId] = true;
      }
    },
    [multideletetopoff.rejected]: (state, action) => {
      state.loading = false;
      state.successmsg = 'Something went wrong';
    },
    //////////////////////////// Edit Multiple Item ///////////////////////////////
    // [usereditmultiple.pending]: (state, action) => {
    //   state.loading = true;
    // },
    // [usereditmultiple.fulfilled]: (state, action) => {
    //   if (action.payload.status === "success") {
    //     state.loading = false;
    //     state.successmsg = 'Updated Successfully'
    //     state.success = true;
    //   }
    // },
    // [usereditmultiple.rejected]: (state, action) => {
    //   state.loading = false;
    //   state.successmsg = 'Something went wrong';
    // },

    ////////////////////////////////userlistasync for dashboard////////////////
    [getdataforusernext.pending]: (state, action) => {
      state.loading = true;
      state.userlistasyncone_flag=1;
    },
    [getdataforusernext.fulfilled]: (state, action) => {
      console.log("action", action);
      if (action.payload.status === "success") {
        state.userlistasyncdata = { ...state.userlistasyncdata, ...action.payload.result };
        state.loading = false;
        state.submitting = false;
        state.userlistasyncone_flag=2;
        
      }
    },
    [getdataforusernext.rejected]: (state, action) => {
      state.loading = false;
      state.userlistasyncone_flag=3;
    },

    [getdataforuser.pending]: (state, action) => {
      state.loading = true;
    },
    [getdataforuser.fulfilled]: (state, action) => {
      console.log("action", action);
      if (action.payload.status === "success") {
        // setTimeout(() => {
        state.userlistasyncdata = { ...action.payload.result };
        state.loading = false;
        state.userlistasyncflag = true;
        // console.log('Waiting.......')
        // }, 3000)
        state.submitting = false;
      }
      // state.userlistasyncdata = [...action.payload.result];
    },
    [getdataforuser.rejected]: (state, action) => {
      state.loading = false;
    },

    //////////////////////////////////// Fetching City List ///////////////////////////////
    [getCityList.pending]: (state, action) => {
      state.cities = ["Loading..."];
    },
    [getCityList.fulfilled]: (state, action) => {
      state.cities = [...action.payload.result];
    },
    [getCityList.rejected]: (state, action) => {
      state.cities = ["No Cities Found !"];
    },
 //////////////////////////////////// change account type  ///////////////////////////////
 [userAccountChange.pending]: (state, action) => {
  state.loading = true;
  state.manageAccountflag=1
},
[userAccountChange.fulfilled]: (state, action) => {
  
    state.loading = false; 
    state.manageAccountflag=2
  
  
},
[userAccountChange.rejected]: (state, action) => {
  state.loading = true;
  state.manageAccountflag=3
},
    //////////////////////////////////// Fetching User List ///////////////////////////////\
    [getList.pending]: (state, action) => {
      state.submitting = true;
    },
    [getList.fulfilled]: (state, action) => {
      if (action.payload.status === "success") {
        // setTimeout(() => {
        state.users = [...action.payload.res];
        // console.log('Waiting.......')
        // }, 3000)
        state.submitting = false;
      }
      console.log(
        "action.payuload of user list admin------------------------------",
        action.payload.res.filter((user) => user.type === "admin")
      );
    },
    [getList.rejected]: (state, action) => {
      state.submitting = false;
    },
    //////////////////////////////////// Fetching User  ///////////////////////////////\
    [getUserData.pending]: (state, action) => {
      state.submitting = true;
    },
    [getUserData.fulfilled]: (state, action) => {
      if (action.payload.status === "success") {
        // setTimeout(() => {
        state.profileinfo = [action.payload.results.res[0]];
        // console.log('Waiting.......')
        // }, 3000)
        state.submitting = false;
      }
    },
    [getUserData.rejected]: (state, action) => {
      state.submitting = false;
    },
    ////////////////////////////////////// Adding users //////////////////////////////////
    [addUser.pending]: (state, action) => {
      state.submitting = true;
      console.log("addUser pending.action==>", action);
      console.log("addUser pending.state==>", state);
      state.message = null;
      state.submitted = false;
      // state.addUserData.push(action.meta.arg);
    },
    [addUser.fulfilled]: (state, action) => {
      console.log("addUser.action==>", action);
      console.log("addUser.state==>", state);

      state.submitting = false;
      if (action.payload.status === "success") {
        action.payload.newData._id = action.payload.result._id;
        action.payload.newData.createdon_datetime =
          action.payload.result.createdon_datetime;
        console.log(
          "==== action.payload.newData ======",
          action.payload.newData
        );
        state.users = [...state.users, action.payload.newData];

        state.message = action.payload.message;
        state.submitted = true;
      }
      if (action.payload.status === "error") {
        state.message = action.payload.msg;
        state.submitted = false;
      }
    },
    [addUser.rejected]: (state, action) => {
      state.message = "Server Failed To Response";
      state.submitting = false;
    },
    ///////////////////////////////////////////// Update User ///////////////////////////////////
    [updateUser.pending]: (state, action) => {
      state.submitting = true;
      state.message = null;
      state.submitted = false;
    },
    [updateUser.fulfilled]: (state, action) => {
      state.submitting = false;
      if (action.payload?.status === "success") {
        console.log(
          "newData--------------------------",
          action.payload.newData
        );
        state.message = action.payload.messag;
        state.submitted = true;
        state.tpm_topoff_access_flag = 2;
      }
      // if (action.payload.status === "error") {
      //   state.message = action.payload.msg;
      //   state.submitted = false;
      // }
    },
    // [updateUser.pending]: (state, action) => {
    //   // state.submitting = false;
    // },

    //////////////////////////////////// Fetching topoff List ///////////////////////////////\
    [getPieChartData.pending]: (state, action) => {
      state.submitting = true;
    },
    [getPieChartData.fulfilled]: (state, action) => {
      if (action.payload.status === "success") {
        // setTimeout(() => {
        state.topoffdataforpichart = action.payload.results.jugsCount;
        state.pichartdayscount = action.payload.results.daysCount;
        state.tpmcount = action.payload.results.valuesCount;
        // console.log('Waiting.......')
        // }, 3000)
        state.submitting = false;
      }
    },
    [getPieChartData.rejected]: (state, action) => {
      state.submitting = false;
    },

    //////////////////////////////////////////// Update tpm ///////////////////////////////////
    [addEditTpm.pending]: (state, action) => {
      state.submitting = true;
      state.message = null;
      state.submitted = false;
    },
    [addEditTpm.pending]: (state, action) => {
      state.submitting = false;
      if (action.payload.status === "success") {
        console.log(
          "newData--------------------------",
          action.payload.newData
        );
        state.message = action.payload.msg;
        state.submitted = true;
      }
      if (action.payload.status === "error") {
        state.message = action.payload.msg;
        state.submitted = false;
      }
    },
    [addEditTpm.pending]: (state, action) => {
      // state.submitting = false;
    },
  },
});
export const { setSuccessAfterSubmit, setProductAccessOfShop ,resetManageaccountflag,resetTpmTopoffflag,resetUserlistasyncone_flag} = userdashboard.actions;
export default userdashboard.reducer;
